import React from 'react'
import Typography from 'antd/es/typography'
import { useAppSelector } from '../../redux/hooks'
import { selectThemeStyle } from '../../features/setting/setting.slice'

const { Text: AntText, Title: AntTitle } = Typography

interface CustomTextProps {
  size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl'
  fontWeight?: number
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
  textStyle?: 'normal' | 'italic' | 'strong'
  type?: 'secondary' | 'success' | 'warning' | 'danger'
}

interface CustomTitleProps {
  level?: 1 | 2 | 3 | 4 | 5
  children: React.ReactNode
  className?: string
  textStyle?: string
  style?: React.CSSProperties
}

export const Text: React.FC<CustomTextProps> = ({
  size = 'base',
  fontWeight,
  children,
  type,
  textStyle = 'normal',
  style = {},
  ...props
}) => {
  const theme = useAppSelector(selectThemeStyle)

  const textStyleMap: Record<
    NonNullable<CustomTextProps['textStyle']>,
    { fontWeight: number; fontStyle: React.CSSProperties['fontStyle'] }
  > = {
    normal: { fontWeight: 400, fontStyle: 'normal' },
    italic: { fontWeight: 400, fontStyle: 'italic' },
    strong: { fontWeight: 500, fontStyle: 'normal' },
  }

  const resolved = textStyleMap[textStyle]

  const fontSizeMap = {
    xs: theme.fontSizeXS,
    sm: theme.fontSizeSM,
    base: theme.fontSizeBase,
    lg: theme.fontSizeLG,
    xl: theme.fontSizeXL,
  }

  return (
    <AntText
      type={type}
      style={{
        fontSize: fontSizeMap[size],
        fontWeight: resolved.fontWeight ?? fontWeight,
        fontStyle: resolved.fontStyle,
        ...style,
      }}
      {...props}
    >
      {children}
    </AntText>
  )
}

export const Title: React.FC<CustomTitleProps> = ({
  level = 1,
  children,
  style = {},
  ...props
}) => {
  return (
    <AntTitle
      level={level}
      style={{
        ...style,
      }}
      {...props}
    >
      {children}
    </AntTitle>
  )
}

// Export an object that mimics the original Typography component structure
const IdeyaTypography = {
  Text,
  Title,
}

export default IdeyaTypography
